export var DIVIDAS_FILTERS_KEY = 'dividasTributarias';

export var DIVIDAS_SCOPES = ['federal', 'estadual', 'municipal', 'inss', 'fgts', 'dirpf'];

export var getDefaultDividasFilters = function() {
    return {
        showArchived: false,
        scopeFilter: null,
        search: '',
    };
};

// Guards against a stale/garbled saved entry before it reaches the screen.
export var normalizeDividasFilters = function(filters) {
    var f = filters || {};
    return {
        showArchived: f.showArchived === true,
        scopeFilter: DIVIDAS_SCOPES.indexOf(f.scopeFilter) >= 0 ? f.scopeFilter : null,
        search: typeof f.search === 'string' ? f.search : '',
    };
};

// /dividas params: only "arquivadas" is server-side.
export var getDividasRequest = function(filters) {
    return { show_archived: filters.showArchived ? 'true' : 'false' };
};

// Badge: only what differs from the defaults.
export var countActiveDividasFilters = function(filters, defaults) {
    return (filters.showArchived !== defaults.showArchived ? 1 : 0) +
        (filters.scopeFilter !== defaults.scopeFilter ? 1 : 0) +
        (filters.search ? 1 : 0);
};
